import React, { useEffect } from "react";
import Switch from "react-switch";
import config from "../../utils/globalConfig";
import { useDispatch, useSelector } from "react-redux";
import { systemActions } from "../../logic/actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const SwitchSwap = ({
  variant = "default",
  enableRedirect = false,
  ...props
}) => {
  const navigate = useHistory();
  const { tab } = useSelector((state) => state.system);
  const dispatch = useDispatch();
  const { order } = useSelector((state) => state.yodaOrders);

  const applyVariant = () => {
    const variantDic = {
      default: {
        width: 30,
        height: 15,
        handleDiameter: 20,
      },
      contained: {
        width: 30,
        height: 15,
      },
    };
    return variantDic[variant] || {};
  };

  useEffect(() => {
    if (order?.orderTypeId !== null && order?.orderTypeId !== undefined) {
      const type = order.orderTypeId === config.ORDER_TYPE_REORDER ? 0 : 1;
      if (tab !== null && tab !== undefined) {
        dispatch(systemActions.setTab(tab));

        if (enableRedirect && type === 1) {
          navigate.push("/catalogue/" + order.id);
        }
      } else {
        dispatch(systemActions.setTab(type));
      }
    }
  }, [order?.orderTypeId]);

  function click() {
    dispatchEvent(
      new CustomEvent("switchOrderRequest", {
        bubbles: true,
      }),
    );
  }

  return (
    <Switch
      checkedIcon={false}
      uncheckedIcon={false}
      checked={order?.orderTypeId === config.ORDER_TYPE_SWAP}
      onChange={click}
      onColor="#888888"
      {...applyVariant()}
      {...props}
    />
  );
};

export default SwitchSwap;
